module.exports = __webpack_public_path__ + "static/media/50.503b1a06.jpg";